/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import PropTypes from "prop-types";
import {FaChevronRight} from "react-icons/fa";
import "./breadcrumb.scss";

/** This component will display breadcrumb item with text and right icon */

const BreadcrumbItem = (props) => {
  const {breadcrumbClasses = "", breadcrumbText, iconClasses = "", onClick} = props;
  return (
    <span className="breadcrumb-item-container">
      <span
        className={`breadcrumb-item roboto-normal ${breadcrumbClasses}`}
        data-cy="breadcrumb_element"
        onClick={onClick}
      >
        {breadcrumbText}
      </span>
      <span className={`right-icon ${iconClasses}`}>
        <FaChevronRight />
      </span>
    </span>
  );
};

BreadcrumbItem.propTypes = {
  /** Text to be displayed on breadcrumb item */
  breadcrumbText: PropTypes.string.isRequired,
  /** Classes to be applied on breadcrumb item */
  breadcrumbClasses: PropTypes.string,
  /** Classes to be applied on right icon */
  iconClasses: PropTypes.string,
  /** Callback function which will be executed on click of breadcrumb item */
  onClick: PropTypes.func.isRequired,
};

export default BreadcrumbItem;
